import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import LoginForm from "./components/LoginForm";
import AdminDashboard from "./pages/AdminDashboard";
import Absensi from "./pages/Absensi";
import UnggahWajah from "./pages/UnggahWajah";
import KaryawanDashboard from "./pages/KaryawanDashboard"; // Import KaryawanDashboard
import StickyFooter from "./components/StickyFooter";
import { UserProvider } from "./context/UserContext"; // Import UserProvider

const App = () => {
  const location = useLocation();
  const hideFooterPaths = ["/login", "/register"];

  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginForm />} />
        {/* <Route path="/register" element={<RegisterForm />} /> */}
        <Route path="/dashboard" element={<AdminDashboard />} />
        <Route path="/absensi" element={<Absensi />} />
        <Route path="/unggahwajah" element={<UnggahWajah />} />
        <Route path="/dashboardkaryawan" element={<KaryawanDashboard />} />
      </Routes>
      {!hideFooterPaths.includes(location.pathname) && <StickyFooter />}
    </>
  );
};

const AppWrapper = () => (
  <UserProvider>
    <Router>
      <App />
    </Router>
  </UserProvider>
);

export default AppWrapper;
